import { FC } from 'react';
import { IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { NavigationMenuToggle } from '../navigation/NavigationMenu';
import { HeaderTabs, IHeaderTabGroup } from '../HeaderTabs';
import { SIDE_NAV_WIDTH } from '../navigation/NavConstants';
import { BeaSonarButton } from '../helper-bee/BeaSonarButton';
import { mediaMinWidth } from '../theme/utils';

const useStyles = createUseStyles({
    header: {
        borderBottom: 'var(--app-theme-border)',
        position: 'relative',
        background: [
            'radial-gradient(120% 140% at 82% 0%, rgba(238, 108, 78, 0.22), transparent 62%)',
            'linear-gradient(180deg, var(--ion-color-primary) 0%, var(--ion-color-primary-shade) 100%)'
        ].join(', '),

        // No toolbar colour: a coloured toolbar paints its own background over the band.
        '& > ion-toolbar': {
            '--color': 'white',
            '--background': 'transparent',
            '--border-width': 0
        }
    },
    title: {
        textAlign: 'center',
        paddingRight: 70,

        [mediaMinWidth.lg]: {
            paddingLeft: SIDE_NAV_WIDTH + 20,
        }
    },
    beaButtonWrapper: {
        position: 'absolute',
        top: 'calc(env(safe-area-inset-top, 0px) + 22px)',
        right: 22,
        zIndex: 100
    }
});

export interface IBasicHeader {
    title?: React.ReactNode;
    children?: React.ReactNode;
    tabs?: IHeaderTabGroup;
    /** Lines the tabs up with a page whose content takes the window's width rather than the reading column. */
    fullWidth?: boolean;
    hidesBeaButton?: boolean;
}

export const BasicHeader: FC<IBasicHeader> = ({ title, children, tabs, fullWidth, hidesBeaButton }) => {
    const classes = useStyles();
    return (
        <IonHeader className={classes.header}>
            <IonToolbar style={{paddingLeft: 10, paddingRight: 10}}>
                <NavigationMenuToggle slot="start" />
                <IonTitle className={classes.title}>
                    {title}
                </IonTitle>
                {children}
            </IonToolbar>
            {tabs &&
                <HeaderTabs tabs={tabs} fullWidth={fullWidth} />
            }
            {tabs && !hidesBeaButton && (
                <div className={classes.beaButtonWrapper}>
                    <BeaSonarButton
                        trackingFrom="Header Button"
                        data-id="bea-header-button"
                    />
                </div>
            )}
        </IonHeader>
    );
};
